import React from 'react';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import useAffordance from 'Hooks/useAffordance';
import fr from 'facet-rest';
import InvestmentKnowledgeAssessmentSectionPicker
  from '../ResourceSections/InvestmentKnowledgeAssessment/InvestmentKnowledgeAssessmentSectionPicker';
import Navigator from '../UI/Navigator';
import InvestmentOther from '../Sections/InvestmentOther';

const FinancialProfile = () => {
  const { householdResource } = useSimpleHousehold();
  const {
    collection: clientCollection,
  } = useAffordance(householdResource?.relationship(fr.relationships.clients.name).link('related'), {
    onlyRunOnMount: true,
  });
  const primaryClientResource = clientCollection?.resources().list().find(c => c.attr('isPrimary') === 'true');

  return (
    <Navigator>
      <InvestmentKnowledgeAssessmentSectionPicker clientResource={primaryClientResource} />
      <InvestmentOther />
    </Navigator>
  );
};

export default FinancialProfile;
